import { FC } from 'react';
import { styled } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '../Box';
import { AlertProps } from '../Alert';

const StyledStripe = styled(Box, {
  name: 'AppBarStripe',
  slot: 'root',
})(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

export type StripeProps = AlertProps;

/**
 * Stripe for `AppBar` and `useModuleProps().setSlotContent`. It can utilize button action in opposite to Alert and has neutral background color.
 */
const Stripe: FC<StripeProps> = ({ icon, action, children, ...other }) => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <StyledStripe {...other}>
      {icon}
      <Box
        display="flex"
        flexDirection={mdUp ? 'row' : 'column'}
        alignItems={mdUp ? 'center' : 'stretch'}
        flex={1}
        gap={1}
      >
        <Box display="flex" flexDirection="column" flex={1}>
          {children}
        </Box>
        {action}
      </Box>
    </StyledStripe>
  );
};

Stripe.displayName = 'AppBar.Stripe';

export default Stripe;
